var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleDownFilledUnhovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 0C10.8395 0 11.3057 0.969997 10.7818 1.62475L6.78154 6.62434C6.38122 7.12467 5.62021 7.12468 5.21989 6.62434L1.21965 1.62475C0.695772 0.969998 1.16193 0 2.00047 0H10.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDownFilledUnhovered);
export default __webpack_public_path__ + "static/media/triangle-down-filled-unhovered.e7e8f812451cc0074cd12c9398ccf7c5.svg";
export { ForwardRef as ReactComponent };